// extracted by mini-css-extract-plugin
module.exports = {"defaultContainer":"Main_defaultContainer__2TOKc","fullWidthContainer":"Main_fullWidthContainer__1Qejl","menu-drawer":"Main_menu-drawer__1iiZw"};